import { render, staticRenderFns } from "./cart.vue?vue&type=template&id=1be34654&scoped=true&"
import script from "./cart.vue?vue&type=script&lang=js&"
export * from "./cart.vue?vue&type=script&lang=js&"
import style0 from "./cart.css?vue&type=style&index=0&id=1be34654&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be34654",
  null
  
)

export default component.exports